export default class Header extends HTMLElement {
  constructor() {
    super();

    // Bindings
    this.onResize = this.onResize.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.clickToggleMenu = this.clickToggleMenu.bind(this);
    this.onMouseenter = this.onMouseenter.bind(this);
    this.onMouseleave = this.onMouseleave.bind(this);
    this.clickVoCloseBtn = this.clickVoCloseBtn.bind(this);

    // Selectors
    this._node = this;
    this._header = document.querySelector('header');
    this._announcement_bar = this._node.querySelector('#announcement-bar');
    this._menu_btn = this._node.querySelector('#menu-btn');
    this._dropdown_btn = this._node.querySelectorAll('.dropdown-btn');
    this._vo_close_btn = this._node.querySelectorAll('.vo-close-btn');

    this._customer_portal_menu = document.querySelector('.customer-portal-menu');

    this._menu_wrapper = this._node.querySelector('#menu-wrapper');
    this._menu_scroll = this._node.querySelector('#menu-scroll');

    // Events
    window.addEventListener('resize', this.onResize);
    window.addEventListener('scroll', this.onScroll);
    this.onResize();
    this.onScroll();

    this._menu_btn.addEventListener('click', this.clickToggleMenu);
    this._dropdown_btn.forEach((el, i) => {
      el.addEventListener('click', this.clickToggleMenu);
      // el.addEventListener('mouseenter', this.onMouseenter);
      // el.addEventListener('mouseleave', this.onMouseleave);
    });
    this._current_dropdown_btn = null;
    this._menu_wrapper.addEventListener('mouseenter', this.onMouseenter);
    this._menu_wrapper.addEventListener('mouseleave', this.onMouseleave);

    this._vo_close_btn.forEach((el) => {
      el.addEventListener('click', this.clickVoCloseBtn);
    });

    // Setup: Check for announcement bar...
    if (this._announcement_bar) {
      if (this._customer_portal_menu) {
        this._customer_portal_menu.classList.add('space-bar');
      }
    } else {
      document.body.classList.add('no-announcement');
    }
  }

  onResize() {
    let ww = window.innerWidth;

    // Close menu if open form mobile, scaling up to desktop...
    if (ww >= 1024 && this._node.classList.contains('show-menu')) {
      this.closeMenu();
    }
  }

  // Scroll
  onScroll() {
    let event_horizon = window.pageYOffset;

    if (this._announcement_bar) {
      if (event_horizon > 0 && !this._node.classList.contains('shrink')) {
        this._node.classList.add('shrink');
        if (this._customer_portal_menu) {
          this._customer_portal_menu.classList.add('shrink');
        }
      } else if (event_horizon <= 0 && this._node.classList.contains('shrink')) {
        this._node.classList.remove('shrink');
        if (this._customer_portal_menu) {
          this._customer_portal_menu.classList.remove('shrink');
        }
      }
    }
  }

  clickToggleMenu(e) {
    this._current_dropdown_btn = e.currentTarget;

    if (this._node.classList.contains('show-menu')) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  clickVoCloseBtn() {
    this.closeMenu();
  }

  closeMenu() {
    this._node.classList.remove('show-menu');

    if (this._menu_scroll) {
      document.body.style.overflow = '';
    }

    if (this._current_dropdown_btn) {
      let focus_id = this._current_dropdown_btn.getAttribute('data-id'),
          focus_wrapper = document.getElementById(focus_id),
          focus_el = focus_wrapper ? focus_wrapper.querySelector('.vo-close-btn') : false,
          label = focus_id === 'menu-mobile' ? 'Open main menu' : 'Open shop dropdown menu';

      this._current_dropdown_btn.setAttribute('aria-label', label);

      if (focus_el) {
        focus_el.removeAttribute('tabindex');
        setTimeout(() => {
          this._current_dropdown_btn.focus();
          this._current_dropdown_btn = null;
        }, 0);
      }
    }
  }

  openMenu() {
    this._node.classList.add('show-menu');

    if (this._menu_scroll) {
      this._menu_scroll.scrollTop = 0;
      document.body.style.overflow = 'hidden';
    }

    if (this._current_dropdown_btn) {
      let focus_id = this._current_dropdown_btn.getAttribute('data-id'),
          focus_wrapper = document.getElementById(focus_id),
          focus_el = focus_wrapper ? focus_wrapper.querySelector('.vo-close-btn') : false,
          label = focus_id === 'menu-mobile' ? 'Close main menu' : 'Close shop dropdown menu';

      this._current_dropdown_btn.setAttribute('aria-label', label);

      setTimeout(() => {
        if (focus_el && this._node.classList.contains('show-menu')) {
          focus_el.setAttribute('tabindex', '-1');
          setTimeout(() => {
            focus_el.focus();
          }, 0);
        }
      }, 666);
    }
  }

  onMouseenter() {
    this.openMenu();
  }

  onMouseleave() {
    this.closeMenu();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('scroll', this.onScroll);

    this._menu_btn.removeEventListener('click', this.clickToggleMenu);
    this._dropdown_btn.forEach((el, i) => {
      el.removeEventListener('click', this.clickToggleMenu);
      // el.removeEventListener('mouseenter', this.onMouseenter);
      // el.removeEventListener('mouseleave', this.onMouseleave);
    });
    this._menu_wrapper.removeEventListener('mouseenter', this.onMouseenter);
    this._menu_wrapper.removeEventListener('mouseleave', this.onMouseleave);

    this._vo_close_btn.forEach((el) => {
      el.removeEventListener('click', this.clickVoCloseBtn);
    });
  }
}
